import { Component, inject } from '@angular/core';

import { Environment } from '../../../../../environments/environment';
import { StateService } from '../../../../services/state/state';

@Component({
  imports: [],
  selector: 'app-listing-details-sidebar-sell-cta',
  styleUrl: './sell-cta.css',
  templateUrl: './sell-cta.html',
})
export class ListingDetailsSidebarSellCta {
  private readonly _stateService = inject(StateService);

  protected postMessage(type: 'RELOCATE' | 'SELL'): void {
    // if (environment.isApp) {
    //   this.stateService.notifyParentOfStateChange(`HF_EVENT:LISTING_DETAILS_${type}_CLICKED`);
    // }
    // else {
    const _origin = Environment.isApp ? 'https://www.thevillages.com' : '';
    const _typePath = type === 'RELOCATE' ? 'relocate' : 'sell-home';
    const _url = `${_origin}/${_typePath}/`;

    const _newWindow = window.open(_url, '_blank');
    if (_newWindow) {
      _newWindow.opener = null; // Add this line to prevent the new window from having access to the opener's context for security reasons
    }
    // }
  }
}
